import { useCallback, useEffect, useRef, useState } from "react";

const Reco = typeof window !== "undefined" ? window.SpeechRecognition || window.webkitSpeechRecognition : null;

export function useDictee(onFinal) {
  const [actif, setActif] = useState(false);
  const [interim, setInterim] = useState("");
  const reco = useRef(null);
  const rappel = useRef(onFinal);
  rappel.current = onFinal;

  const arreter = useCallback(() => { reco.current?.stop(); setActif(false); setInterim(""); }, []);
  const demarrer = useCallback(() => {
    if (!Reco) return false;
    const r = new Reco();
    r.lang = "fr-FR";
    r.interimResults = true;
    r.continuous = false;
    r.onresult = (e) => {
      let provisoire = "";
      for (let i = e.resultIndex; i < e.results.length; i += 1) {
        const t = e.results[i][0].transcript;
        if (e.results[i].isFinal) rappel.current?.(t.trim());
        else provisoire += t;
      }
      setInterim(provisoire);
    };
    r.onend = () => { setActif(false); setInterim(""); };
    r.onerror = () => { setActif(false); setInterim(""); };
    reco.current = r;
    r.start();
    setActif(true);
    return true;
  }, []);
  useEffect(() => () => reco.current?.abort?.(), []);
  return { actif, interim, demarrer, arreter, supporte: Boolean(Reco) };
}
